// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reg_main_content .carousel_content .el-carousel__item {\n  background-color: transparent;\n}", ""]);
// Exports
module.exports = exports;
